import { LogOut, User, HelpCircle } from 'lucide-react';
import { useAuthStore } from '@/stores/authStore';
import { authApi } from '@/api/auth';
import { useNavigate, Link } from 'react-router-dom';
import MobileNav from './MobileNav';

export default function Header() {
  const { user, logout, accessibleCompanies } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await authApi.logout();
    } catch (error) {
      console.error('ログアウトエラー:', error);
    } finally {
      logout();
      navigate('/login');
    }
  };

  return (
    <header className="bg-white border-b border-gray-200 px-4 sm:px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2 sm:space-x-4">
          {/* モバイルナビゲーション */}
          <MobileNav />

          <h1 className="text-lg sm:text-xl font-bold text-primary">majiraku</h1>
          <span className="hidden sm:inline text-sm text-gray-500">UTAGE分析ダッシュボード</span>
        </div>

        <div className="flex items-center space-x-2 sm:space-x-4">
          <div className="flex items-center space-x-2">
            {user?.avatar_url ? (
              <img
                src={user.avatar_url}
                alt={user.full_name}
                className="w-8 h-8 rounded-full"
              />
            ) : (
              <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center">
                <User className="w-4 h-4 text-gray-500" />
              </div>
            )}
            <span className="hidden sm:inline text-sm font-medium">
              {user?.role === 'super_admin'
                ? user?.full_name
                : accessibleCompanies[0]?.display_name || accessibleCompanies[0]?.name || user?.full_name}
            </span>
            <span className="hidden md:inline text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
              {user?.role === 'super_admin' ? '管理者' : '法人管理者'}
            </span>
          </div>

          <Link
            to="/help"
            className="flex items-center space-x-1 text-gray-500 hover:text-primary transition-colors"
            title="使い方ガイド"
          >
            <HelpCircle className="w-5 h-5" />
            <span className="hidden sm:inline text-sm">ヘルプ</span>
          </Link>

          <button
            onClick={handleLogout}
            className="flex items-center space-x-1 text-gray-500 hover:text-gray-700"
            title="ログアウト"
          >
            <LogOut className="w-4 h-4" />
            <span className="hidden sm:inline text-sm">ログアウト</span>
          </button>
        </div>
      </div>
    </header>
  );
}
